import { LoadingCart, SimpleSpinner } from 'src/components/common';
import { useGetOrgUsers } from 'src/hooks';
import type { OrgMember } from 'src/types';
import { UserDetails, UsersEmptyOrError } from '.';

type Props = {
  handleClickRemoveUser: (user: OrgMember) => void;
};

export const UsersListOrEmpty = ({ handleClickRemoveUser }: Props) => {
  const usersQuery = useGetOrgUsers();

  if (usersQuery.isLoading) {
    return (
      <Container>
        <LoadingCart customBgColor='bg-transparent' />
      </Container>
    );
  }

  if (
    usersQuery.isError ||
    usersQuery.data?.pages.flatMap((page) => page.users).length === 0
  ) {
    return (
      <Container>
        <UsersEmptyOrError isError={usersQuery.isError} />
      </Container>
    );
  }

  return (
    <ul className='flex w-full flex-col items-start justify-center gap-0 overflow-y-hidden overflow-x-scroll lg:overflow-x-hidden'>
      {usersQuery.data?.pages
        .flatMap((page) => page.users)
        .map((orgUser, i) => (
          <UserDetails
            key={`user-${orgUser.id}-${i}`}
            orgUser={orgUser}
            handleClickRemoveUser={handleClickRemoveUser}
          />
        ))}
      {usersQuery.isFetchingNextPage && (
        <div className='mx-auto w-fit py-6'>
          <SimpleSpinner
            customWidth='w-12'
            customHeight='h-12'
            customPosition='block'
          />
        </div>
      )}
    </ul>
  );
};

const Container = ({ children }: { children: React.ReactNode }) => (
  <div className='flex flex-col items-center justify-center px-2 pb-20 pt-6 sm:pt-10 md:pt-14'>
    {children}
  </div>
);
